export const eventSwitchList = [
	{ label: '启用', value: 1 },
	{ label: '停用', value: 0 },
]

export const eventSwitchObj = {
	启用: 1,
	停用: 0,
}

export const columns = [
	{ key: 'no', name: '序号', fixed: 'left', tooltip: true, width: 60, dragDisable: true, disabledSelect: true },
	{ key: 'eventModelConfigId', name: '编号', fixed: 'left', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'deviceTypeName', name: '设备类型名称', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'eventId', name: '报警ID', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'eventName', name: '报警名称', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'eventLevel', name: '报警等级', slot: 'eventLevel', tooltip: true, dragDisable: true, disabledSelect: true },
	{
		key: 'eventSwitch',
		name: '报警启用状态',
		slot: 'eventSwitch',
		tooltip: true,
		dragDisable: true,
		disabledSelect: true,
	},
	{ key: 'pushWechat', name: '微信推送', slot: 'pushWechat', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushSms', name: '短信推送', slot: 'pushSms', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushPage', name: '页面推送', slot: 'pushPage', tooltip: true, dragDisable: true, disabledSelect: true },
	{ key: 'pushVoice', name: '声音警告', slot: 'pushVoice', tooltip: true, dragDisable: true, disabledSelect: true },
]

export const generateSearchFormItems = deviceTypeList => {
	return [
		{
			prop: 'deviceTypeIdList',
			keyWord: '设备类型',
			type: 'select',
			width: '320px',
			needAllForSearch: true,
			filterable: true,
			searchOption: deviceTypeList,
			multiple: true,
		},
		{
			prop: 'eventName',
			keyWord: '报警名称',
			type: 'input',
			width: '320px',
		},
		{
			prop: 'eventSwitch',
			keyWord: '报警启用状态',
			type: 'select',
			width: '320px',
			searchOption: eventSwitchList,
			needAllForSearch: true,
		},
	]
}
